document.addEventListener('DOMContentLoaded', () => {
  const printButtons = document.querySelectorAll('.js-print');

  printButtons.forEach((printButton) => {
    printButton.addEventListener('click', (event) => {
      event.preventDefault();
      window.print();
    });
  });
});
